import { policies } from './policies';
export class UndefinedRuleError extends Error {
    constructor(subject, op, object) {
        const message = `I am an error from access policies, I was thrown because you are trying to make me check a rule that does not exist using can(). The afromentioned rule is for the subject "${subject}", the operation "${op}" and the object "${object.toString()}". Please check access/policies.`;
        super(message);
        this.subject = subject;
        this.operation = op;
        this.object = object;
    }
}
/*
- Policies describe access control with an object of the following form :
  {
    [subject]: {
      [op(eration)]: {
        [object]: rule
      }
    }
  }
*/
export const makeCan = () => function can(subject, op, object, args) {
    const rule = policies[subject][op][object];
    if (!rule)
        throw new UndefinedRuleError(subject, op, object);
    return rule(subject, op, object, args);
};
